import { render, staticRenderFns } from "./AttachmentsDialog.vue?vue&type=template&id=17dc506f&scoped=true&"
import script from "./AttachmentsDialog.vue?vue&type=script&lang=js&"
export * from "./AttachmentsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsDialog.vue?vue&type=style&index=0&id=17dc506f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dc506f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VForm,VTab,VTabItem,VTabs,VTabsItems})
